const initialState = () => ({
  mode: null,
  selector: null,
  position: null,
  notation: null,
  created_by_user: null
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    assign(
      state,
      {
        created_by_user,
        selector = null,
        position = null,
        mode = null,
        notation = null
      }
    ) {
      state.created_by_user = created_by_user
      state.selector = selector
      state.position = position
      state.mode = mode
      state.notation = notation
    },
    notation(state, notation) {
      state.notation = notation
    },
    reset(state) {
      Object.assign(state, initialState())
    }
  }
}
